import React from "react";
import { usePageMeta } from "../hooks/usePageMeta";
import { useLocation } from "react-router-dom";
import { HeroCTAs } from "../components/HeroCTAs";
import { CityLocalSection } from "../components/CityLocalSection";
import Header from "../components/Header";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEOVillesReunion from "../components/SEOVillesReunion";
import FAQSection from "../components/FAQSection";
import StatsSection from "../components/StatsSection";
import WhyChooseSection from "../components/WhyChooseSection";
import { getSeoPage, SITE } from "../data/seoSlug.mjs";

export default function SeoLandingPage() {
  const { pathname } = useLocation();
  const page = getSeoPage(pathname);

  usePageMeta({ title: page.title, description: page.description, url: `${SITE}/${page.slug}`, local: page.local });

  return (
    <div className="min-h-screen bg-black" data-testid="seo-landing-page">
      <Header />
      <section id="accueil" className="relative overflow-hidden lux-section-glow">
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 md:pt-10 pb-20 text-center fade-up">
          <span className="inline-block mb-4 px-5 py-2 rounded-full border border-amber-500/30 bg-amber-500/5 text-amber-300 text-xs sm:text-sm tracking-[0.25em] uppercase">
            Maître Diamma · La Réunion 974
          </span>
          <h1 className="font-heading text-3xl sm:text-5xl font-semibold gold-text mb-5 leading-tight" data-testid="seo-landing-title">{page.h1}</h1>
          <div className="gold-divider w-40 mx-auto mb-6" />
          {page.intro.map((p) => (
            <p key={p} className="text-zinc-300 text-base md:text-lg mb-4 leading-relaxed">{p}</p>
          ))}
          <div className="mt-10"><HeroCTAs prefix="seo-landing" /></div>
        </div>
      </section>
      {page.local && <CityLocalSection local={page.local} />}
      <StatsSection />
      <Services />
      <WhyChooseSection />
      <SEOVillesReunion />
      <FAQSection />
      <Contact />
      <Footer />
    </div>
  );
}
